module.exports = __webpack_public_path__ + "img/pdf-thumbnail.381ef637.png";